import React, {Component, Fragment,} from 'react'
import {message, Form, Input, InputNumber, Table, Button, Popconfirm,} from 'antd'
import {
    reqGetVehicle, reqGetDrivers, baseUrl, hscreenBaseUrl, hscreenBaseUrlM
} from '../../api'
import ajax from "../../api/ajax";
import {SECRET_KEY_M} from '../../utills/constants'
import FileUpload from './file-upload'
import CryptoJS from '../../utills/crypto'
//import {download} from '../../utills/picture-download'
import {getVehicleInfo} from '../../utills/common'
class VehicleDriver extends Component {
    constructor(props) {
        super(props);
        this.state = {
            readOnly: true,
            vehicle: {},
            fileList: [],//车辆行驶证 附件列表
            drivers: [],
            record: {filePhotoList: [], fileDriverList: []},
        };
        this.realBaseUrl = baseUrl;
        this.secretKey = null;
        if (props.exterior) {
            this.realBaseUrl = hscreenBaseUrl;
            if (props.deliveryType === 'M') {
                this.realBaseUrl = hscreenBaseUrlM;
                this.secretKey = SECRET_KEY_M;
            }
        }
        this.columns = [
            {
                title: '姓名',
                dataIndex: 'name',
            }, {
                title: '手机',
                dataIndex: 'phone',
            }, {
                title: '身份证',
                dataIndex: 'identification',
            }
        ];
    }

    componentDidMount() {
        this.setState({readOnly: !this.props.edit});
        this.getVehicle();
        this.getDrivers();
    }

    componentDidUpdate(preProps, preState, snapShot) {
        //readOnly动态改变时
        if (this.props.edit !== preProps.edit) {
            this.setState({readOnly: !this.props.edit})
        }
    }

    getVehicle = async () => {
        const {orderId, type, form} = this.props;
        const result = await reqGetVehicle({orderId, type});
        if (result.code === 200) {
            const vehicle = {
                id: result.data.id,
                orderId,
                truckNo: result.data.truckNo,
                hangNo: result.data.hangNo,
                weight: result.data.weight,
            };
            form.setFieldsValue(result.data);
            result.data.fileList = this.setFileUrl(result.data.fileList);
            this.setState({vehicle, fileList: result.data.fileList});
        }
    };
    getDrivers = async () => {
        const {orderId, type, exterior} = this.props;
        const result = await reqGetDrivers({orderId, type});
        if (result.code === 200) {
            (result.data || []).forEach((d, index) => {
                d.filePhotoList = this.setFileUrl(d.filePhotoList);
                d.fileDriverList = this.setFileUrl(d.fileDriverList);
            });
            this.setState({drivers: result.data}, function () {
                if (exterior) {
                    this.getFileList();
                }
            });
        }
    };
    getFileList = async () => {
        const {orderNo} = this.props;
        let result = await ajax(this.realBaseUrl + '/d/public/scan/overseaFile', {content: CryptoJS.encrypt(JSON.stringify({orderNo}), this.secretKey)});
        if (result.code === 200) {
            const {drivers} = this.state;
            result.data.drivingLicenseFiles = this.setFileUrl(result.data.drivingLicenseFiles);
            //外部接口中司机附件 关联到 司机
            (result.data.driverFiles || []).forEach((item) => {
                item.fileVos = this.setFileUrl(item.fileVos);
            });
            drivers.forEach((d) => {
                const filePhotoList = [];//身份证
                const fileDriverList = [];//驾照
                (result.data.driverFiles || []).forEach((exteriorDriver) => {
                    //根据司机姓名关联
                    if (d.name == exteriorDriver.driver) {
                        (exteriorDriver.fileVos || []).forEach((exteriorFileVo) => {
                            //根据fileType区分 身份证与驾照
                            if (exteriorFileVo.objectType == 'o_driver_photo') {
                                filePhotoList.push(exteriorFileVo)
                            }
                            if (exteriorFileVo.objectType == 'o_driver_license') {
                                fileDriverList.push(exteriorFileVo)
                            }
                        });
                    }
                });
                d.filePhotoList = filePhotoList;
                d.fileDriverList = fileDriverList;
            });
            this.setState({fileList: result.data.drivingLicenseFiles, drivers: [...drivers]});
        } else {
            message.error(result.message)
        }
    };
    setFileUrl = (fileList) => {
        (fileList || []).forEach((item, index) => {
            item.uid = index;
            item.name = item.fileName;
            item.status = 'done';
            item.url = this.realBaseUrl + '/' + item.filePath;
            item.thumbUrl = item.url;
        });
        return fileList;
    };
    downloadFiles = () => {
        const {type, exterior, orderId, orderNo,} = this.props;
        let url;
        if (exterior) {
            url = this.realBaseUrl + "/d/public/vehicleFileDownload?content=" + encodeURIComponent(CryptoJS.encrypt(JSON.stringify({orderNo}), this.secretKey));
        } else {
            url = this.realBaseUrl + "/api/v1/p/file/vehicleFileDownload?orderId=" + orderId + "&ioType=" + type;
        }
        window.open(url, "_blank");
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {type, exterior, orderId, orderNo, deliveryType,} = this.props;
        const {readOnly, vehicle, fileList, drivers, view, action, record} = this.state;
        const formItemLayout = {
            labelCol: {span: 6},
            wrapperCol: {span: 14},
        };
        if (!readOnly && this.columns.length === 3) {
            this.columns.push({
                title: '操作',
                width: 90,
                dataIndex: 'opt',
                render: (text, record) => {
                    return <Fragment>
                        <a onClick={() => this.clickUpdate(record)}>修改</a>&nbsp;
                        <Popconfirm title="是否确定删除?" onConfirm={() => this.del(record.id, record.orderId)}>
                            <a>删除</a>
                        </Popconfirm>
                    </Fragment>
                }
            })
        }
        return (
            <div className="vehicle-driver">
                <div className="vehicle-driver-head flex-between">
                    <div className="tab">{type === 'O' ? '境外' : '境内'}</div>
                    <div className="other"></div>
                </div>
                <div className="vehicle-driver-content">
                    <div className="title flex-between">
                        <div>车辆</div>
                        <div> {readOnly ? null : <Button type='link' onClick={this.handleSubmit}>保存</Button>}</div>
                    </div>
                    {readOnly ?
                        <Fragment>
                            <div>车牌号 : {getVehicleInfo(vehicle.truckNo, vehicle.hangNo)}</div>
                            {deliveryType === 'X' ? <div>车自重(吨): {vehicle.weight}</div> : null}
                        </Fragment> :
                        <Form {...formItemLayout}>
                            <Form.Item label="车牌号">
                                {getFieldDecorator('truckNo', {
                                    rules: [{required: type === 'I', message: '该项必填'}],
                                })(<Input readOnly={readOnly}/>)}
                            </Form.Item>
                            <Form.Item label="挂号">
                                {getFieldDecorator('hangNo', {})(<Input readOnly={readOnly}/>)}
                            </Form.Item>
                            {deliveryType === 'X' ?
                                <Form.Item label="车自重(吨)">
                                    {getFieldDecorator('weight', {})(
                                        <InputNumber min={0} style={{width: '100%'}} readOnly={readOnly}/>)}
                                </Form.Item> : null}
                        </Form>
                    }
                    <div className="title flex-between">
                        <div>驾驶员</div>
                        <div> {readOnly ? null :
                            <Button type='link' onClick={this.clickAdd} disabled={vehicle.id == null}>新增</Button>}</div>
                    </div>
                    <Table className='detail'
                           columns={this.columns}
                           bordered
                           pagination={false}
                           dataSource={drivers}
                           size="middle"/>
                    <div className="title flex-between">
                        <div>附件</div>
                        <div><Button type='link' onClick={this.downloadFiles}
                                     disabled={!(Array.isArray(fileList) && fileList.length > 0)}>批量下载</Button></div>
                    </div>
                    <FileUpload vehicleId={vehicle.id}
                                orderId={orderId} orderNo={orderNo}
                                objectId={vehicle.id}
                                objectType={type === 'O' ? 'o_driving_license' : 'i_driving_license'}
                                fileList={fileList}
                                setFileList={(list) => this.setState({fileList: list})}
                                readOnly={readOnly}
                                exterior={exterior}
                                deliveryType={deliveryType}/>
                </div>
            </div>
        )
    }
}
const VehicleDriverForm = Form.create()(VehicleDriver);
export default VehicleDriverForm